// pl_pms_housekeeping.ts
// Tłumaczenia dla PMS.Housekeeping.tsx

export const plPmsHousekeeping = {

  title: "Housekeeping",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomControl:   "Kontrola pokoi",
    roomSnapshot:  "Stan pokoi",
    tasks:         "Zadania housekeepingu",
    maintenance:   "Konserwacja i blokowanie",
    realtimeFeed:  "Feed na żywo",
    operations:    "Operacje",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    roomReadiness: "Gotowość pokoi, zarządzanie zadaniami, konserwacja, blokowanie i operacje w czasie rzeczywistym.",
    fastUpdates:   "Szybkie aktualizacje statusu pokoi z bezpiecznym zapisem.",
    currentState:  "Aktualny stan operacyjny.",
    createTrack:   "Twórz i śledź operacyjne zadania pokojowe.",
    escalate:      "Eskaluj usterki techniczne i chroń inwentarz.",
    prepared:      "Przygotowane do przyszłego streamingu zdarzeń na urządzeniach pracowników.",
  },

  // ── Typy zadań ────────────────────────────────────────────────────────────
  taskTypes: {
    inspection:       "Inspekcja",
    turndown:         "Turndown",
    deepClean:        "Gruntowne sprzątanie",
    maintenanceFollowUp: "Kontrola po konserwacji",
    taskType:         "Typ zadania",
  },

  // ── Statusy pokoi (specyficzne dla HK) ───────────────────────────────────
  roomStatus: {
    clean:     "Czysty",
    dirty:     "Brudny",
    cleaning:  "W sprzątaniu",
    inspected: "Skontrolowany",
    blocked:   "Zablokowany",
  },

  // ── Konserwacja i blokowanie ──────────────────────────────────────────────
  maintenance: {
    severity:    "Ważność usterki",
    blockRoom:   "Zablokuj pokój",
    releaseBlock:"Zwolnij blokadę",
    resolved:    "Rozwiązane przez serwis, przekazane do sprzątania.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    priority:          "Priorytet",
    housekeepingStatus:"Status housekeepingu",
    unassigned:        "Nieprzypisany",
  },

  // ── Komunikaty błędów ─────────────────────────────────────────────────────
  messages: {
    blockFailed:            "Blokada pokoju nieudana.",
    blockReleaseFailed:     "Zwolnienie blokady nieudane.",
    maintenanceReportFailed:"Zgłoszenie konserwacji nieudane.",
    maintenanceUpdateFailed:"Aktualizacja konserwacji nieudana.",
    roomUpdateFailed:       "Aktualizacja pokoju nieudana.",
    taskCreationFailed:     "Tworzenie zadania nieudane.",
    taskUpdateFailed:       "Aktualizacja zadania nieudana.",
  },

} as const;

export default plPmsHousekeeping;
